/**
 * Целевая сущность для которой осуществляется действие
 */
export var TournamentFeatureActionTarget;
(function (TournamentFeatureActionTarget) {
    TournamentFeatureActionTarget["User"] = "User";
    TournamentFeatureActionTarget["Team"] = "Team";
})(TournamentFeatureActionTarget || (TournamentFeatureActionTarget = {}));
